namespace Portico.Models.Enterprise {
	import pmg = Portico.Models.Gateway;

	export interface IContactPreference {
		contactInfoType: pmg.ContactInfoType;
		isOptedIn: boolean;
		isPreferred: boolean;
    }

	export class ContactPreference implements IContactPreference {
		contactInfoType: pmg.ContactInfoType;
		isOptedIn: boolean;
		isPreferred: boolean;

		constructor(obj?: IContactPreference) {
			this.contactInfoType = null;
			this.isOptedIn = false;
			this.isPreferred = false;

			if (obj) {
				this.contactInfoType = obj.contactInfoType || null;
				this.isOptedIn = obj.isOptedIn || false;
				this.isPreferred = obj.isPreferred || false;
            }
        }
    }
}
